import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t('contact.form.required');
    if (!values.email.trim()) e.email = t('contact.form.required');
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) e.email = t('contact.form.invalidEmail');
    if (!values.message.trim()) e.message = t('contact.form.required');
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onChange = (k) => (ev) => setValues((v) => ({ ...v, [k]: ev.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    navigate('/thank_you');
  };

  return (
    <form className="auro-form" onSubmit={onSubmit} noValidate data-testid="contact-form">
      <div className="auro-form__row">
        <label htmlFor="cf-name">{t('contact.form.name')}</label>
        <input
          id="cf-name"
          type="text"
          placeholder={t('contact.form.namePlaceholder')}
          value={values.name}
          onChange={onChange('name')}
          data-testid="cf-name"
          aria-invalid={!!errors.name}
        />
        {errors.name && <span className="auro-form__err">{errors.name}</span>}
      </div>
      <div className="auro-form__row">
        <label htmlFor="cf-email">{t('contact.form.email')}</label>
        <input
          id="cf-email"
          type="email"
          placeholder={t('contact.form.emailPlaceholder')}
          value={values.email}
          onChange={onChange('email')}
          data-testid="cf-email"
          aria-invalid={!!errors.email}
        />
        {errors.email && <span className="auro-form__err">{errors.email}</span>}
      </div>
      <div className="auro-form__row">
        <label htmlFor="cf-message">{t('contact.form.message')}</label>
        <textarea
          id="cf-message"
          rows={5}
          placeholder={t('contact.form.messagePlaceholder')}
          value={values.message}
          onChange={onChange('message')}
          data-testid="cf-message"
          aria-invalid={!!errors.message}
        />
        {errors.message && <span className="auro-form__err">{errors.message}</span>}
      </div>
      <p className="auro-form__consent">{t('contact.form.consent')}</p>
      <button type="submit" className="auro-btn auro-btn--primary auro-btn--full" data-testid="cf-submit">
        {t('contact.form.submit')}
      </button>
    </form>
  );
}
